import { IEmployeeWorkgroupState } from '@/store/employee-workgroup';
import { IEmployeeWorkgroupMutations } from './mutations.types';
import { IEmployeeWorkgroupData } from '@/models';

export const mutations: IEmployeeWorkgroupMutations = {
  SET_WORKGROUPS(
    state: IEmployeeWorkgroupState,
    payload: IEmployeeWorkgroupData[]
  ): void {
    state.employeeWorkgroups = payload;
  },

  ADD_WORKGROUP(
    state: IEmployeeWorkgroupState,
    payload: IEmployeeWorkgroupData
  ): void {
    state.employeeWorkgroups.push(payload);
  },

  UPDATE_WORKGROUP(
    state: IEmployeeWorkgroupState,
    payload: IEmployeeWorkgroupData
  ): void {
    const index = state.employeeWorkgroups.findIndex(
      (employeeWorkgroup: IEmployeeWorkgroupData) =>
        employeeWorkgroup.id === payload.id
    );

    state.employeeWorkgroups.splice(index, 1, payload);
  },

  REMOVE_WORKGROUP(state: IEmployeeWorkgroupState, payload: number): void {
    const index = state.employeeWorkgroups.findIndex(
      (employeeWorkgroup: IEmployeeWorkgroupData) =>
        employeeWorkgroup.id === payload
    );

    state.employeeWorkgroups.splice(index, 1);
  }
};
